"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var AXSBlock_1 = __importDefault(require("../../layout/AXSBlock/AXSBlock"));
var AXSFlex_1 = __importDefault(require("../../layout/AXSFlex"));
var AXSIcon_1 = __importDefault(require("../AXSIcon"));
var classnames_1 = __importDefault(require("classnames"));
var colors_1 = require("../../constants/colors");
var utils_1 = require("../../utils");
var Notification = styled_components_1.default(AXSFlex_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n  min-height: 60px;\n  padding-right: ", ";\n  position: relative;\n"], ["\n  background-color: ",
    ";\n  min-height: 60px;\n  padding-right: ", ";\n  position: relative;\n"])), function (_a) {
    var theme = _a.theme, type = _a.type;
    return utils_1.parseThemePath("axsui.status." + type + ".default", theme, colors_1.colors.BLUE_300);
}, function (_a) {
    var button = _a.button;
    return (button ? '10px' : '50px');
});
var Content = styled_components_1.default(AXSBlock_1.default)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  color: ", ";\n  order: -1;\n  width: 100%;\n"], ["\n  color: ", ";\n  order: -1;\n  width: 100%;\n"])), colors_1.colors.WHITE);
var Dismiss = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: block;\n  position: absolute;\n  right: 10px;\n  top: 15px;\n"], ["\n  display: block;\n  position: absolute;\n  right: 10px;\n  top: 15px;\n"])));
var Button = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject([""], [""])));
var AXSNotification = function (_a) {
    var borderRadius = _a.borderRadius, button = _a.button, children = _a.children, className = _a.className, handleClose = _a.handleClose, showMore = _a.showMore, theme = _a.theme, type = _a.type, props = __rest(_a, ["borderRadius", "button", "children", "className", "handleClose", "showMore", "theme", "type"]);
    var classes = [
        'c-axs-notification',
        { 'c-axs-notification--active': showMore },
        className,
    ];
    return (React.createElement(Notification, { className: classnames_1.default(classes), alignItems: "center", type: type, borderRadius: borderRadius, padded: true },
        button ? (React.createElement(Button, null, button)) : (React.createElement(Dismiss, { className: "c-axs-event-banner__expander", onClick: handleClose },
            React.createElement(AXSIcon_1.default, { size: "30px", color: colors_1.colors.WHITE, name: "close", style: { cursor: 'pointer' } }))),
        React.createElement(Content, __assign({ className: "c-axs-notification__content" }, props), children)));
};
AXSNotification.defaultProps = {
    type: 'info',
};
/** @component */
exports.default = AXSNotification;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=index.js.map